// extracted by mini-css-extract-plugin
module.exports = {"list":"list--1lUTM","item":"item--3-UTy","title":"title--3Xto6"};